import { useMutation } from 'react-query';
import { postCompanyLogo } from '../apis/PostCompanyLogo';

export const usePostCompanyLogoMutation = () => useMutation(postCompanyLogo);
